import { todayTz } from "@/libraries/date";
import { parseDate } from "@/libraries/dayjs-relative";
import { CreateOrUpdateCalendarFieldSchema } from "@/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { Outlet, createFileRoute, useSearch } from "@tanstack/react-router";
import { useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";

export const Route = createFileRoute("/dashboard/calendar")({
	component: RouteComponent,
});

function RouteComponent() {
	const searchDate = useSearch({
		strict: false,
		select: (s) => s.date,
	});

	const defaultValues = useMemo(() => {
		const date = searchDate ? parseDate(searchDate, "DD-MM-YYYY") : todayTz();
		return {
			date,
			end: date.add(30, "minutes"),
			title: "",
		};
	}, [searchDate]);

	const formMethod = useForm<CreateOrUpdateCalendarFieldSchema>({
		mode: "all",
		resolver: zodResolver(CreateOrUpdateCalendarFieldSchema),
		defaultValues,
	});

	return (
		<FormProvider {...formMethod}>
			<div className="flex flex-col h-full overflow-hidden">
				<Outlet />
			</div>
		</FormProvider>
	);
}
